import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

interface RequestEmailOtpResponseData extends ResponseData {
  message: string
}

export interface RequestEmailOtpResponse extends AxiosResponse {
  data: RequestEmailOtpResponseData
}

export function requestEmailOtpAPI(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "post",
    url: `/auth/resend-email-otp`,
  }) as Promise<RequestEmailOtpResponse>
}
